import React from 'react'
import { Button, MenuItem } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { Field, Form } from 'react-final-form'
import { connect } from 'react-redux'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import {
  fetchProjectedSitesManagerList,
  saveListForm,
  setActiveSite,
} from 'reducers/projectedSitesManager/reducer'
import withPromise from 'helpers/withPromise'
import { Select } from 'components/common/FormInputs'
import messages from '../translate'

function CreateForm({
  intl: { formatMessage },
  activeSite,
  onPanelClose,
  clientsList,
  fetchProjectedSitesManagerList,
  siteType,
  selectedSnapshot: snapshot,
  setActiveSite,
  saveListForm,
  storePsfs,
}) {
  const fullWidth = ifWindowWidthLessThan(599)

  const onSubmitForm = ({ id, clientName }) => {
    const data = {
      clientId: clientName,
      enabled: true,
    }

    withPromise(saveListForm, {
      data,
      id,
      sucessMessage: formatMessage(messages.siteUpdatedSuccessfully),
      isEditMode: false,
      siteType,
      snapshot,
    }).then(() => {
      onPanelClose()
      fetchProjectedSitesManagerList({
        psfs: storePsfs,
        siteType,
        snapshot,
      })
    })
  }

  const onChangeSelect = (value, field) => {
    if (value && activeSite[field] !== value) {
      setActiveSite({ [field]: value })
    }

    return value
  }

  return (
    <Form
      onSubmit={onSubmitForm}
      initialValues={activeSite}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="event-details-form">
          <div className="form-group">
            <Field
              required
              name="clientName"
              component={Select}
              label={formatMessage(messages.clientName)}
              formControlProps={{
                fullWidth: true,
                required: true,
              }}
              validate={getValidator([VALIDATOR_IS_EMPTY])}
              parse={value => onChangeSelect(value, 'clientName')}>
              {clientsList.map(({ clientId, clientName }) => (
                <MenuItem key={clientId} value={clientId}>
                  {clientName}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="form-button-group">
            <Button
              href={null}
              type="button"
              color="default"
              size="medium"
              variant="contained"
              onClick={onPanelClose}
              className="cancel-event-btn"
              fullWidth={fullWidth}>
              {formatMessage(messages.cancel)}
            </Button>
            <Button
              href={null}
              type="submit"
              color="primary"
              size="medium"
              variant="contained"
              onClick={handleSubmit}
              className="save-event-btn"
              fullWidth={fullWidth}>
              {formatMessage(messages.save)}
            </Button>
          </div>
        </form>
      )}
    />
  )
}

export default connect(
  state => ({
    activeSite: state.getIn(['projectedSitesManager', 'activeSite']),
    clientsList: state.getIn(['projectedSitesManager', 'clientsList']),
    sitesList: state.getIn(['projectedSitesManager', 'sitesList']),
    regionsList: state.getIn(['projectedSitesManager', 'regionsList']),
    speciesList: state.getIn(['projectedSitesManager', 'speciesList']),
    productFamilyList: state.getIn([
      'projectedSitesManager',
      'productFamilyList',
    ]),
    storePsfs: state.getIn(['projectedSitesManager', 'storePsfs']),
  }),
  {
    setActiveSite,
    saveListForm,
    fetchProjectedSitesManagerList,
  },
)(injectIntl(CreateForm))
